import {
  type ProductActionIconType,
  type ProductGrade,
  type ProductGradeResponse,
} from './types.d';

export const FILTER_WIDTH = 250;
export const DEFAULT_PRODUCT_ACTION_COLOR = '#9EC272';

export const PRODUCT_ACTION_TYPES_MAP: Record<
  ProductActionIconType,
  { color: string; label: string }
> = {
  HOT: {
    color: '#E56862',
    label: 'HOT',
  },
  SALE: {
    color: '#E56862',
    label: 'SALE',
  },
  SPECIAL_OFFER: {
    color: '#E56862',
    label: 'SPECIAL_OFFER',
  },
  NEW: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: 'NEW',
  },
  COMN: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: 'COMN',
  },
  FRAR: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: 'FRAR',
  },
  OTHER: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: 'OTHER',
  },
  SUPER_PRICE: {
    color: '#826EC5',
    label: 'SUPER_PRICE',
  },
  GIFT: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: 'GIFT',
  },
  NONE: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: 'NONE',
  },
  QUDIS: {
    color: '#826EC5',
    label: 'QUDIS',
  },
  ROOT: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: '',
  },
  ALL: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: '',
  },
  CUSTOM: {
    color: DEFAULT_PRODUCT_ACTION_COLOR,
    label: '',
  },
};

export const SEPARATOR_HEADER_ROW = 'separator-header-row';

export const PRODUCT_GRADE_MAP: Record<ProductGradeResponse, ProductGrade> = {
  Q: 'A+',
  N: 'BN',
  S: 'S',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
};

export const PRODUCT_Y_VALUE_WHEN_SHOW_PANEL = 700;

export const TEMPORARY_ORDER_PRODUCT_TABLE_FIELD_MAP = {
  SKU: 'product.sku',
  DESCRIPTION: 'product.title',
  UNITS: 'product.logistic.packsInBox',
  REQUESTED_QUANTITY: 'requestedQuantity',
  REQUESTED_ARRIVAL_DATE: 'requestedArrivalDate',
  PRICE: 'product.price.actualPrice',
  SUBTOTAL: 'subtotal',
  ACTIONS: 'actions',
};
